export default function getOutletDrop(getStore, outlet) {
  const drop = structuredClone(outlet.drop)
  drop['store'] = getStore
  return drop
}